import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import ParkingLossReason from "../../../../commons/model/ParkingLossReason";
import { generateRoute } from "../../../../commons/utils/Router";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_ADMIN_PARKING_LOSS_REASON_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface ParkingLossReasonListTableProps {
    data: ParkingLossReason[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

function goToItemDetail(itemId: string): void {
  goToRoute(generateRoute(ROUTE_ADMIN_PARKING_LOSS_REASON_DETAIL, {
    id: itemId,
  } ));
};
export default class ParkingLossReasonListTable extends React.Component<ParkingLossReasonListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((parkingLossReason: ParkingLossReason) => (
            <tr key={parkingLossReason.id}
              onClick={() => goToItemDetail(parkingLossReason.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(parkingLossReason.id) : null}
              <td>
                {parkingLossReason.name ? parkingLossReason.name : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.NOMBRE)}
          columnName={"name"}
          {...commonProps}
        />
      </tr>
    );
  }
}
